import { makeVar, ReactiveVar } from '@apollo/client';

type Credential = { [key: string]: string };

class CredentialStorage implements Storage {
  credentialVar: ReactiveVar<Credential | undefined>;

  constructor() {
    this.credentialVar = makeVar<Credential | undefined>(undefined);
  }

  public clear(): void {
    this.credentialVar(undefined);
  }

  public getItem(key: string): string {
    return this.credentialVar()?.[key] ?? '';
  }

  public setItem(key: string, value: string): void {
    const existData = this.credentialVar() ?? {};

    this.credentialVar({
      ...existData,
      [key]: value,
    });
  }

  public removeItem(key: string): void {
    const existData = this.credentialVar() ?? {};

    this.credentialVar({
      ...existData,
      [key]: '',
    });
  }

  public get length(): number {
    return Object.getOwnPropertyNames(this.credentialVar() ?? {}).length;
  }

  public key(index: number): string {
    return Object.getOwnPropertyNames(this.credentialVar() ?? {})[index];
  }
}

export default CredentialStorage;
